import styled, { css } from 'styled-components';
import cssKit from '../../css';

const nissan = process.env.BRAND_NAME === 'nissan';

export const StyledEstimatorTitleWrapper = styled.div`
  text-align: center;
`;

export const StyledEstimatorTitle = styled.h1`
  font-family: ${nissan ? cssKit.fonts.bold : cssKit.fonts.light};
  margin-bottom: .6rem;

  ${!nissan && css`
    font-size: 2.3rem;
    padding-top: 10px;
  `}
`;

export const StyledEstimatorByline = styled.p`
  margin-bottom: 0;
  font-family: ${cssKit.fonts.regular}

  ${!nissan && css`
    margin-bottom: 1.5em;
    font-weight: 200;
    font-style: normal;
    margin-top: 0 !important;
  `}
`;



/** WEBPACK FOOTER **
 ** ./src/components/Title/styles.js
 **/